export default function email(message = 'Email Inválido') {
  return (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || message
}
